import styled from '@emotion/styled';

import breakPoints from 'app/styles/constants/breakpoints';
import RGBA from 'app/styles/rgbToRgbaConverter';
import { startDirection } from 'app/styles/selectors/markup';

const { widthSmall, widthMedium, widthLarge } = breakPoints;

const HeroBlock = styled.section`
  label: HeroBlock;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 6.5rem;
  padding-bottom: 2.5rem;
  text-align: center;
  background-color: ${RGBA('--colors-black', 0.9)};

  @media (${widthSmall}) {
    background-color: initial;
    padding: 6rem 2.75rem 2.3rem;
  }

  @media (${widthMedium}) {
    background-color: initial;
    padding-top: 6.5rem;
  }

  @media (${widthLarge}) {
    padding-bottom: 3rem;
  }
`;

const ImageWrapper = styled.div`
  label: ImageWrapper;

  position: absolute;
  top: 0;
  ${startDirection}: 0;
  width: 100%;
  height: 100%;
  z-index: var(--z-index-under-background);
`;

const Image = styled.img`
  label: Image;

  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative;
`;

const MigrationLogo = styled.img`
  label: MigrationLogo;

  width: 10.33125rem;
  height: 2rem;
  margin-bottom: 1rem;

  @media (${widthSmall}) {
    margin-bottom: 1.5rem;
  }

  @media (${widthMedium}) {
    width: 16rem;
    height: 3rem;
    margin-bottom: 2.25rem;
  }
`;

const BlackWrapper = styled.div`
  label: BlackWrapper;

  @media (${widthSmall}) {
    background-color: ${RGBA('--colors-black', 0.9)};
    padding: 2.5rem;
  }

  @media (${widthMedium}) {
    padding: 2.5rem 0;
  }
`;

const UpsellWrapper = styled.div`
  label: UpsellWrapper;

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 1.25rem;
  max-width: 37.5rem;

  @media (${widthSmall}) {
    padding: 0;
  }

  @media (${widthMedium}) {
    max-width: initial;
  }
`;

const Title = styled.h1`
  label: Title;

  color: var(--colors-white);
  margin-bottom: 1rem;
  max-width: 18rem;

  @media (${widthSmall}) {
    max-width: 37.5rem;
  }
`;

const SubTitle = styled.h1`
  label: SubTitle;

  color: var(--colors-silver);
  margin-bottom: 1.5rem;

  @media (${widthSmall}) {
    max-width: 42.5rem;
  }
`;

const Notice = styled.span`
  label: Notice;

  color: var(--colors-silver-chalice);
  margin-bottom: 2.5rem;
`;

const PerksHolder = styled.div`
  label: PerksHolder;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.375rem 2rem;

  @media (${widthSmall}) {
    max-width: 37.5rem;
    gap: 1.3rem 5rem;
  }

  @media (${widthMedium}) {
    width: 86%;
    max-width: 70rem;
    grid-template-columns: repeat(4, 1fr);
    margin-bottom: 1rem;
    gap: 1.5rem 5rem;
  }
`;

const PromotionRequirements = styled.div`
  label: PromotionRequirements;

  color: var(--colors-silver-chalice);

  @media (${widthSmall}) {
    max-width: 37.5rem;
  }

  @media (${widthLarge}) {
    max-width: 36rem;
  }
`;

const Styled = {
  HeroBlock,
  Image,
  ImageWrapper,
  BlackWrapper,
  UpsellWrapper,
  Title,
  Notice,
  PromotionRequirements,
  MigrationLogo,
  SubTitle,
  PerksHolder,
};

export default Styled;
